export default function makeLinksClickable(text) {
    // Регулярний вираз для знаходження URL-адрес
    const urlRegex = /\b(?:https?|ftp):\/\/[-A-Za-z0-9+&@#\/%?=~_|!:,.;]*[-A-Za-z0-9+&@#\/%=~_|]/g;

    const textInBracketsRegex = /\[(.*?)\]|\((.*?)\)/g;

    const newText = text.replace(textInBracketsRegex, (match, textInBrackets, urlInBrackets) => {
        if (urlInBrackets) {
            // Якщо знайдено посилання у круглих дужках, видаляємо їх
            return urlInBrackets;
        } else if (textInBrackets) {
            // Якщо знайдено текст у квадратних дужках, замінюємо його на порожній рядок
            return "";
        }
    }).replace(urlRegex, (url) => {
        // Замінюємо посилання на клікабельні посилання
        return `<a href="${url}" class="bot_link" style="text-decoration: underline;" target="_blank">${url}</a>`;
    });

    return newText;
}
